import * as React from "react";
import { Demo1 } from "./Demo1";

export const Sheet2Page: React.FC = () => <Demo1 />;
